<script setup>
</script>

<template>
  <div class="tw-min-h-screen tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-12">
    <div class="tw-w-full tw-max-w-md tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-8 tw-text-center">
      <div class="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
        <SvgVue
          icon="icons/tick-green"
          class="tw-w-16 tw-h-16"
        />
      </div>

      <h1 class="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-3">
        Payment successful!
      </h1>
      <p class="tw-text-gray-500">
        Thank you for your purchase. Our team will be in touch shortly to get started on your strategy.
      </p>

      <a
        href="https://www.hikeseo.co"
        class="tw-mt-6 tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-text-neutral-400 hover:tw-text-neutral-600 tw-transition-colors tw-duration-150"
      >
        <SvgVue
          icon="icons/chevron"
          class="tw-w-2.5 tw-h-2.5 tw-rotate-180"
        />
        Back to Hike
      </a>
    </div>
  </div>
</template>
